module.exports = __webpack_public_path__ + "img/源汇区.2489d6b3.png";